import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { DemoUnitsEditMode } from './components/demoUnitsEditMode/DemoUnitsEditMode'
import { DemoUnitsReadMode } from './components/demoUnitsReadMode/DemoUnitsReadMode'
import { TRANSLATION_KEYS } from './translations'

import styles from './DemoUnits.module.scss'

interface IDemoUnitsProps {
  demoUnits: Nullable<number>
  isRetail?: boolean
  isDistributor?: boolean
}

export const DemoUnits: FC<IDemoUnitsProps> = (props) => {
  const isEditMode = useSelector(selectPublishingMode)

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={TRANSLATION_KEYS.fieldLabel} />
      {!isEditMode && <DemoUnitsReadMode {...props} />}
      {isEditMode && <DemoUnitsEditMode {...props} />}
    </div>
  )
}
